import GridWrapper from "@components/elements/GridWrapper";
import TextFieldWrapper from "@components/wrappers/field/text";
import {
  Box,
  Button,
  Divider,
  FormHelperText,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import { SubmitErrorHandler, SubmitHandler, useForm } from "react-hook-form";

type FormValues = {
  email: string;
  password: string;
};

interface Props {
  onSubmit: (data: FormValues) => void;
}

export default function LoginForm(props: Props): JSX.Element {
  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    return props.onSubmit(data);
  };

  const submit = () => {
    handleSubmit(onSubmit)();
  };

  return (
    <GridWrapper spacing={2}>
      <Typography variant="h4">Sign In</Typography>
      <Divider />

      <TextFieldWrapper
        control={control}
        name="email"
        textFieldProps={{ label: "Email", variant: "filled" }}
      />

      <TextFieldWrapper
        control={control}
        name="password"
        textFieldProps={{
          label: "Password",
          variant: "filled",
          type: "password",
        }}
      />

      <Button
        fullWidth
        variant="contained"
        color="secondary"
        size="large"
        onClick={submit}
      >
        Sign In
      </Button>
    </GridWrapper>
  );
}
